<template>
    <div class="center">
        <my-header  active="2" />
        <div class="main">
            <div class="container clearfix">
                <router-view />
            </div>
        </div>
        <my-footer />
    </div>
</template>

<script>
export default {
    name: 'center',
    components: {

    },
    data(){
        return {
            
        }
    },
    mounted(){
        
    },
    methods:{
        
    }
}
</script>

<style scoped>
    .main{padding-bottom: 100px;}
    .menu{float: left;width: 174px;padding-top: 15px;}
    .menu ul{padding-left: 11px;}
    .menu ul li{height: 20px;line-height: 20px;color: #666666;line-height: 20px;padding-bottom: 44px;padding-left: 19px;position: relative;border-left: 2px solid #999999;}
    .menu ul li:last-child{padding-bottom: 0px;}
    .menu ul li:before{content: '';display: block;width: 20px;height: 20px;background: #999999;border-radius:10px;position: absolute;left: -11px;top: 0;}
    .menu ul li.active{color: #bf371e;}
    .menu ul li.active:before{background: #bf371e;}
    .menu ul li.activeBoder{border-color: #bf371e;}

    .content{float: right;width: 1020px;padding-top: 5px;}

    /*按钮*/
    .center .main >>> .el-button{
        width: 150px;height: 35px;line-height: 35px;padding: 0;margin: 0;border:0;border-radius: 5px;color: #fff;font-size: 14px;
        background: -webkit-linear-gradient(#bf371e, #942424);
        background: -o-linear-gradient(#bf371e, #942424);
        background: -moz-linear-gradient(#bf371e, #942424);
        background: linear-gradient(#bf371e, #942424);
    }
    .center .main >>> .el-button:focus, .center .main >>> .el-button:hover{color: #fff;}
    .center .main >>> .el-button:active{color: #fff;}
    .center .main >>> .el-button.is-disabled{background: #e7e7e7;color: #333;}
    .center .main >>> .el-button.is-disabled:hover{background: #e7e7e7;color: #333;}
    .center .main >>> .el-button+.el-button{margin-left: 40px;}
    /*下拉框&输入框*/
    .center .main >>> .el-input{width: 250px;}
    .center .main >>> .el-input.is-focus .el-input__inner{border-color: #999999;border-radius: 0;}
    .center .main >>> .el-input__inner:focus{border-color: #999999;border-radius: 0;}
    .center .main >>> .el-input__inner{border-color: #999999;border-radius: 0;line-height: 30px;height: 30px;}
    .center .main >>> .el-input__icon{line-height: 30px;}
    .center .main >>> .el-input .el-select__caret{color: #999;}
    /*多选*/
    .center .main >>> .el-checkbox__label{color: #000;}
    .center .main >>> .el-checkbox__label a{color: #bf371e;text-decoration: underline;}
    .center .main >>> .el-checkbox__inner{background: none;border-color: #383838;}
    .center .main >>> .el-checkbox__inner::after{border-color: #383838;}


    .center .main >>> .el-form-item__label{line-height: 30px;}
    .center .main >>> .el-form-item__content{line-height: 30px;}
    .center .main >>> .el-cascader{line-height: 30px;height: 30px;}

    .center .main >>> .el-radio__input.is-checked .el-radio__inner{background: #777;border-color: #777;}
    .center .main >>> .el-radio__inner{border-color: #777;}
    .center .main >>> .el-radio__label{color: #201313;}

    /*.center .main >>> .upload *{transition:all 0s;}*/
	
	
	
	.center >>> .el-table th{background: #f2f2f2; text-align: center;}
	.center >>> .el-table td{ text-align: center;height: 50px;}

    .center .main >>> .el-input.is-focus .el-textarea__inner{border-color: #999999;border-radius: 0;}
    .center .main >>> .el-textarea__inner:focus{border-color: #999999;border-radius: 0;}
    .center .main >>> .el-textarea__inner{border-color: #999999;border-radius: 0;line-height: 30px;height: 30px;}

</style>
